module.exports = __webpack_public_path__ + "static/media/logoWithText.0c0006d0.jpg";